export default "__VITE_ASSET__DSOyEn4v__"